import { IntranetAPI, API } from '../utils/config'

// -----------------------------------------
// ------------- INTRANET ------------------
// -----------------------------------------

// Dashboard Statistics
export function GetDashboardStatsAPI(params) {
	return IntranetAPI.get(`/dashboard/stats/${params ? `?${params}` : ''}`)
}

// Home Stats (lightweight, short cache) — solo cards de propiedades + Brik
export function GetHomeStatsAPI(params) {
	return IntranetAPI.get(`/dashboard/home-stats/${params ? `?${params}` : ''}`)
}

export function GetSubscriptionReportsOverview(qs) {
	return IntranetAPI.get(`/reports/subscriptions/overview/${qs ? `?${qs}` : ''}`)
}

export function GetSubscriptionCancellationDetailsReportAPI(qs) {
	return IntranetAPI.get(`/reports/subscriptions/cancellations/${qs ? `?${qs}` : ''}`)
}

export function ExportSubscriptionCancellationDetailsReportAPI(qs) {
	const params = new URLSearchParams(qs || '')
	params.set('format', 'csv')
	return IntranetAPI.get(`/reports/subscriptions/cancellations/?${params.toString()}`, {
		responseType: 'blob',
	})
}

export function GetCancelSurveysReportAPI(qs) {
	return IntranetAPI.get(`/reports/subscriptions/cancel-surveys/${qs ? `?${qs}` : ''}`)
}

export function ExportCancelSurveysReportAPI(qs) {
	const params = new URLSearchParams(qs || '')
	params.set('format', 'csv')
	return IntranetAPI.get(`/reports/subscriptions/cancel-surveys/?${params.toString()}`, {
		responseType: 'blob',
	})
}

export function GetBrikMainChartsAPI(qs) {
	return IntranetAPI.get(`/reports/brik/main_charts/${qs ? `?${qs}` : ''}`)
}

export function GetBrikMissingFeaturesAPI(qs) {
	return IntranetAPI.get(`/reports/brik/missing_features/${qs ? `?${qs}` : ''}`)
}

export function GetInboxReportAPI(qs) {
	return IntranetAPI.get(`/reports/inbox/${qs ? `?${qs}` : ''}`)
}

export function GetInboxReportAccountsAPI(qs) {
	return IntranetAPI.get(`/reports/inbox/accounts/${qs ? `?${qs}` : ''}`)
}

/**
 * Resumen de Facebook Lead Ads: páginas conectadas y leads por día.
 * @param {string} [qs] Query string sin `?` (ej. `days=30`)
 * @returns {Promise}
 */
export function GetFacebookLeadsReportAPI(qs) {
	return IntranetAPI.get(`/reports/facebook-leads/${qs ? `?${qs}` : ''}`)
}

/**
 * Listado de páginas de Facebook Lead Ads.
 * @param {string} [qs] Query string sin `?`
 * @returns {Promise}
 */
export function GetFacebookLeadsPagesAPI(qs) {
	return IntranetAPI.get(`/reports/facebook-leads/pages/${qs ? `?${qs}` : ''}`)
}

export function CompanyAPI(uid, data) {
	if (data) {
		return IntranetAPI.patch(`/companies/${uid}/`, data)
	} else {
		return IntranetAPI.get(`/companies/${uid}/`)
	}
}
export function GetCompanySupportConversationsAPI(uid, params) {
	return IntranetAPI.get(`/companies/${uid}/support-conversations/`, { params })
}
export function FilterCompanies(qs) {
	return IntranetAPI.get(`/companies/${qs ? `?${qs}` : ''}`)
}
export function ChangeDataCompany(data, uid) {
	return IntranetAPI.patch(`/companies/${uid}/`, data)
}

// -----------------------------------------
// ------------- CSV EXPORT ----------------
// -----------------------------------------
/**
 * Esquema exportable de un recurso (`companies` | `users`).
 * Sin `qs` devuelve el modelo base; `path=config` devuelve los campos de esa
 * relación; `validate=config__show_all_cities` valida un path escrito a mano.
 * @param {'companies'|'users'} resource
 * @param {string} [qs] Query string sin `?`
 * @returns {Promise}
 */
export function GetExportFieldsAPI(resource, qs) {
	return IntranetAPI.get(`/${resource}/export-fields/${qs ? `?${qs}` : ''}`)
}

/**
 * Descarga el CSV de un recurso con las columnas (`fields=a,b__c`) y los
 * filtros del listado. Responde un blob.
 * @param {'companies'|'users'} resource
 * @param {string} qs Query string sin `?`
 * @returns {Promise}
 */
export function ExportCsvAPI(resource, qs) {
	return IntranetAPI.get(`/${resource}/export/${qs ? `?${qs}` : ''}`, { responseType: 'blob' })
}
export function GetProperty(uid) {
	return IntranetAPI.get(`/properties/${uid}/`)
}
export function SearchProperties(value) {
	return IntranetAPI.get(`/properties/?search=${value}`)
}
export function GetProperties() {
	return IntranetAPI.get(`/properties`)
}
export function SortTableUsers(page, value) {
	return IntranetAPI.get(`/users/?page=${page}&sort=${value.id}`)
}
export function ListUsers(params) {
	return IntranetAPI.get(`/users/${params ? `?${params}` : ''}`)
}
export function SortProperties(page, value) {
	return IntranetAPI.get(`/properties/?page=${page}&sort=${value}`)
}
export function ChangeUserCompany(data, uid) {
	return IntranetAPI.patch(`/users/${uid}/`, data)
}
export function UpdateUserAdminAPI(uid, data) {
	return IntranetAPI.patch(`/users/${uid}/admin-update/`, data)
}
export function BulkUpdateUsersAPI(data) {
	return IntranetAPI.patch('/users/bulk-update/', data)
}
/**
 * Reactiva un usuario que fue eliminado (deleted=True).
 * @param {string} uid
 * @returns {Promise}
 */
export function RestoreUserAPI(uid) {
	return IntranetAPI.post(`/users/${uid}/restore/`)
}
/**
 * Historial de activaciones/desactivaciones de un usuario (quién, cuándo,
 * origen y facturación antes/después).
 * @param {string} uid
 * @param {string} [params] Query string sin `?` (ej. `limit=100`)
 * @returns {Promise}
 */
export function GetUserStatusLogsAPI(uid, params) {
	return IntranetAPI.get(`/users/${uid}/status-logs/${params ? `?${params}` : ''}`)
}
export function ListReportLogs(params) {
	return IntranetAPI.get(`properties/reports/?${params}`)
}
export function FilterProperties(qs) {
	return IntranetAPI.get('/properties/' + qs, {})
}
export function FilterRolesAPI(qs) {
	return IntranetAPI.get(`/roles/${qs ? `?${qs}` : ''}`)
}
export function CompanyConfigAPI(pk, data) {
	if (data) {
		return IntranetAPI.patch(`/config/${pk}/`, data)
	} else {
		return IntranetAPI.get(`/config/${pk}/`)
	}
}
export function DeleteCompanyAPI(uid) {
	return IntranetAPI.get(`/company/delete/${uid}/`)
}
export function UpdateBankRatesAPI(id, data) {
	return IntranetAPI.patch(`/update-banks/${id}/`, data)
}
export function FilterContactTypesAPI(qs) {
	return IntranetAPI.get(`/contacts/ctypes/${qs ? `?${qs}` : ''}`)
}
export function FilterSitesAPI(qs) {
	return IntranetAPI.get(`/cms/sites/${qs ? `?${qs}` : ''}`)
}
export function FilterThemesAPI(qs) {
	return IntranetAPI.get(`/cms/themes/${qs ? `?${qs}` : ''}`)
}
export function SiteAPI(id, data) {
	if (id && data) {
		return IntranetAPI.patch(`/cms/sites/${id}/`, data)
	}
	if (!id && data) {
		return IntranetAPI.post(`/cms/sites/`, data)
	}
	return IntranetAPI.get(`/cms/sites/${id}/`)
}
export function SiteConfigurationOptionsAPI(companyId) {
	return IntranetAPI.get(`/cms/sites/configuration-options/?company=${companyId}`)
}
export function RoundRobinsAPI(qs) {
	return IntranetAPI.get(`/campaigns/round-robins/${qs}`)
}

// -----------------------------------------
// ------------- SITES (CMS) ---------------
// -----------------------------------------
export function FilterSiteConfigsAPI(companyId) {
	return IntranetAPI.get(`/cms/configs/?company=${companyId}`)
}
export function FilterUsersForRefToAPI(companyId) {
	return IntranetAPI.get(`/users/?company_id=${companyId}&page_size=100`)
}
export function SiteDnsAPI(siteId) {
	return IntranetAPI.get(`/cms/sites/${siteId}/dns/`)
}
export function CreateSiteDnsRecordAPI(siteId, data) {
	return IntranetAPI.post(`/cms/sites/${siteId}/dns/`, data)
}
export function ApplySiteDnsTemplateAPI(siteId, template) {
	return IntranetAPI.post(`/cms/sites/${siteId}/dns-template/`, { template })
}
export function UpdateSiteDnsRecordAPI(siteId, recordId, data) {
	return IntranetAPI.patch(`/cms/sites/${siteId}/dns/${recordId}/`, data)
}
export function DeleteSiteDnsRecordAPI(siteId, recordId) {
	return IntranetAPI.delete(`/cms/sites/${siteId}/dns/${recordId}/`)
}

// -----------------------------------------
// ------------- SITE CONFIGS --------------
// -----------------------------------------
export function FilterSiteConfigsListAPI(qs) {
	return IntranetAPI.get(`/config/site-configs/${qs ? `?${qs}` : ''}`)
}
export function SiteConfigAPI(id, data) {
	if (id && data) {
		return IntranetAPI.patch(`/config/site-configs/${id}/`, data)
	}
	return IntranetAPI.get(`/config/site-configs/${id}/`)
}
export function NotificationsConfigAPI(companyUid, data) {
	if (data) {
		return IntranetAPI.patch(`/config/notifications-config/${companyUid}/`, data)
	}
	return IntranetAPI.get(`/config/notifications-config/${companyUid}/`)
}
export function RetrieveOnboardingConfig(userUid) {
	return IntranetAPI.get(`/config/onboarding/${userUid}/`)
}
export function UpdateOnboardingConfig(userUid, data) {
	return IntranetAPI.patch(`/config/onboarding/${userUid}/`, data)
}

// -----------------------------------------
// ------------- PORTALS -------------------
// -----------------------------------------
export function ListPortalsAPI() {
	return IntranetAPI.get('/portals/')
}

// -----------------------------------------
// ------------- STRIPE --------------------
// -----------------------------------------
export function GetCompanyStripeInfoAPI(companyUid) {
	return IntranetAPI.get(`/companies/${companyUid}/stripe-info/`)
}

// -----------------------------------------
// ------------- POSTMARK ------------------
// -----------------------------------------
export function GetUserPostmarkEmailsAPI(userUid, params) {
	return IntranetAPI.get(`/users/${userUid}/postmark-emails/${params ? `?${params}` : ''}`)
}

// -----------------------------------------
// ------------- BRIK ----------------------
// -----------------------------------------
export function GetUserBrikMessagesAPI(userUid, params) {
	return IntranetAPI.get(`/users/${userUid}/brik-messages/${params ? `?${params}` : ''}`)
}

// -----------------------------------------
// ------------- POST LOGS -----------------
// -----------------------------------------
export function GetCompanyPostLogsAPI(companyUid, params) {
	return IntranetAPI.get(`/companies/${companyUid}/post-logs/${params ? `?${params}` : ''}`)
}

/**
 * Cambios de propiedades hechos por la API pública de una compañía.
 * @param {string} companyUid
 * @param {string} [search]
 * @returns {Promise}
 */
export function GetCompanyPropertyApiLogsAPI(companyUid, search) {
	const params = search ? `?search=${encodeURIComponent(search)}` : ''

	return IntranetAPI.get(`/companies/${companyUid}/property-api-logs/${params}`)
}

export function RetryCompanyPostLogAPI(companyUid, postlogId) {
	return IntranetAPI.post(`/companies/${companyUid}/retry-post-log/`, { postlog_id: postlogId })
}

export function GetCompanyMetaConversionsAPI(companyUid) {
	return IntranetAPI.get(`/companies/${companyUid}/meta-conversions/`)
}

/**
 * Workflows de una compañía. `created_by` es el UID del agente y
 * `scope` es `company` (global) o `user` (solo sus registros).
 * @param {string} companyUid
 * @param {{ created_by?: string, scope?: string }} [params]
 * @returns {Promise}
 */
export function GetCompanyWorkflowsAPI(companyUid, params) {
	return IntranetAPI.get(`/companies/${companyUid}/workflows/`, { params })
}

/**
 * Árbol de solo lectura de un workflow, para depurarlo desde el admin.
 * @param {string} companyUid
 * @param {string} workflowUid
 * @returns {Promise}
 */
export function GetCompanyWorkflowDetailAPI(companyUid, workflowUid) {
	return IntranetAPI.get(`/companies/${companyUid}/workflows/${workflowUid}/`)
}

// -----------------------------------------
// ------------- FILES ---------------------
// -----------------------------------------
export function UploadFileAPI(formData) {
	return API.post('/files/new/', formData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	})
}

// -----------------------------------------
// ------------- SUBSCRIPTIONS -------------
// -----------------------------------------
export function FilterSubscriptionsAPI(qs) {
	return IntranetAPI.get(`/subscriptions/${qs ? `?${qs}` : ''}`)
}
export function SubscriptionAPI(id, data) {
	if (data) {
		return IntranetAPI.patch(`/subscriptions/${id}/`, data)
	}
	return IntranetAPI.get(`/subscriptions/${id}/`)
}
export function CreateSubscriptionAPI(data) {
	return IntranetAPI.post('/subscriptions/', data)
}
export function SubscriptionStripeDetailAPI(id) {
	return IntranetAPI.get(`/subscriptions/${id}/stripe-detail/`)
}
export function ListPlansAPI(qs) {
	return IntranetAPI.get(`/subscriptions/plans/${qs ? `?${qs}` : ''}`)
}
export function SearchUsersAPI(qs) {
	return IntranetAPI.get(`/subscriptions/users/search/${qs ? `?${qs}` : ''}`)
}
export function SearchCompaniesAPI(qs) {
	return IntranetAPI.get(`/subscriptions/companies/search/${qs ? `?${qs}` : ''}`)
}

// -----------------------------------------
// ------------- TREXO REPORTS -------------
// -----------------------------------------
export function FilterTrexoReportsAPI(qs) {
	return IntranetAPI.get(`/properties/trexo-reports/${qs ? `?${qs}` : ''}`)
}
export function TrexoReportAPI(uid) {
	return IntranetAPI.get(`/properties/trexo-reports/${uid}/`)
}
export function TrexoReportStatsAPI() {
	return IntranetAPI.get(`/properties/trexo-reports/stats/`)
}
export function AssignTrexoReportAPI(uid) {
	return IntranetAPI.post(`/properties/trexo-reports/${uid}/assign/`)
}
export function SendTrexoFeedbackAPI(uid, data) {
	return IntranetAPI.post(`/properties/trexo-reports/${uid}/send-feedback/`, data)
}
export function AddTrexoInternalNoteAPI(uid, data) {
	return IntranetAPI.post(`/properties/trexo-reports/${uid}/add-internal-note/`, data)
}
export function ResolveTrexoReportAPI(uid, data) {
	return IntranetAPI.post(`/properties/trexo-reports/${uid}/resolve/`, data)
}

// -----------------------------------------
// ---- PROPERTY DUPLICATION MIGRATIONS ----
// -----------------------------------------

/**
 * Preview a cross-company property duplication (read-only).
 * @param {{ uids: string[], company: string, options: object }} data
 * @returns {Promise}
 */
export function PreviewPropertyDuplicationAPI(data) {
	return IntranetAPI.post('/properties/duplication-migrations/preview/', data)
}

/**
 * Start a cross-company property duplication job.
 * @param {{ uids: string[], company: string, options: object }} data
 * @returns {Promise}
 */
export function StartPropertyDuplicationAPI(data) {
	return IntranetAPI.post('/properties/duplication-migrations/', data)
}

/**
 * List property duplication migration jobs.
 * @param {string} [qs] Query string without leading ?
 * @returns {Promise}
 */
export function ListPropertyDuplicationsAPI(qs) {
	return IntranetAPI.get(`/properties/duplication-migrations/${qs ? `?${qs}` : ''}`)
}

/**
 * Retrieve a property duplication migration job by uid.
 * @param {string} jobUid
 * @returns {Promise}
 */
export function GetPropertyDuplicationAPI(jobUid) {
	return IntranetAPI.get(`/properties/duplication-migrations/${jobUid}/`)
}

/**
 * List items for a property duplication migration job.
 * @param {string} jobUid
 * @param {string} [qs] Query string without leading ?
 * @returns {Promise}
 */
export function ListPropertyDuplicationItemsAPI(jobUid, qs) {
	return IntranetAPI.get(`/properties/duplication-migrations/${jobUid}/items/${qs ? `?${qs}` : ''}`)
}

/**
 * Request cooperative cancellation of a running duplication job.
 * @param {string} jobUid
 * @returns {Promise}
 */
export function CancelPropertyDuplicationAPI(jobUid) {
	return IntranetAPI.post(`/properties/duplication-migrations/${jobUid}/cancel/`)
}

/**
 * Rollback / delete data created by a duplication job (superuser only).
 * @param {string} jobUid
 * @param {{ preview_only?: boolean, include_legacy_crm?: boolean }} [data]
 * @returns {Promise}
 */
export function RollbackPropertyDuplicationAPI(jobUid, data = {}) {
	return IntranetAPI.post(`/properties/duplication-migrations/${jobUid}/rollback/`, data)
}
